<template>
    <div>
        <!-- HEADER BAR -->
        <div ref="topbar" class="fixed-top">
            <!-- TOP NAV -->
            <nav class="navbar navbar-expand navbar-dark px-0 toolbar">
                <div class="container">
                    <div class="d-flex flex-nowrap flex-row w-100">
                        <div class="align-self-center">
                            <!-- LEFT SIDE ITEMS -->
                            <ul class="navbar-nav mr-3">
                                <li class="nav-item text-white">
                                    <span v-if="affiliate.id" class="d-flex align-items-center">
                                        <span class="mr-2">Shopping with {{affiliate.name}}</span> <img :src="affiliate.portrait" width="25" height="25" class="gravatar rounded-circle">
                                    </span>
                                    <span v-else>
                                        {{stateData.motd}}
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="align-self-center ml-auto">
                            <ul class="navbar-nav">

                                <!-- QUOTE -->
                                <li class="nav-item d-lg-block d-none" v-if="!isHomeschoolStore">
                                    <a href="https://www.studiesweekly.com/get-a-quote/" class="nav-link text-nowrap" target="_blank">
                                        Get Quote
                                    </a>
                                </li>
                                <!-- ORDER FORM -->
<!--                                <li class="nav-item d-lg-block d-none" v-if="!isHomeschoolStore">-->
<!--                                    <router-link :to="`/order-form/${stateData.state}`" target="_blank" class="nav-link text-nowrap">-->
<!--                                        OrderDetails Form-->
<!--                                    </router-link>-->
<!--                                </li>-->

                                <!-- Year Select -->
                                <li class="nav-item d-flex mx-lg-2 mx-auto">
                                    <div class="align-self-center" v-if="$route.name != 'checkout' && $route.name != 'cart'">
                                        <select class="form-control form-control-sm text-capitalize bg-transparent text-white" :value="selectedYear" @change="setSelectedYear">
                                            <option :selected="true" :value="schoolYear">
                                                (<template v-if="showBothSchoolYears">current</template><template v-else>upcoming</template> School Year) {{schoolYear-1}}-{{schoolYear}}
                                            </option>
                                            <option v-if="showBothSchoolYears" :value="schoolYear + 1">(Next School Year) {{schoolYear}}-{{schoolYear + 1}}</option>
                                        </select>
                                    </div>
                                </li>
                                <!-- STATE SELECT -->
                                <li class="nav-item d-flex ml-lg-0 mx-auto" v-if="!isHomeschoolStore">
                                    <div class="align-self-center" v-if="$route.name != 'checkout' && $route.name != 'cart'">
                                        <select class="form-control form-control-sm text-capitalize bg-transparent text-white" :value="selectedState" @change="setSelectedState">
                                            <option :value="null" disabled :selected="true">Select State</option>
                                            <option v-for="state in states" :key="state.state" :value="state.state" class="text-dark">{{state.fullState}}</option>
                                        </select>
                                    </div>
                                </li>
                                <li class="loader" v-show="isLoading"></li>
                            </ul>

                        </div>
                    </div>
                </div>
            </nav>

            <!-- SECOND NAV -->
            <b-navbar id="navbar" class="main-navbar border-bottom" toggleable="lg" type="light" variant="white">
                <div class="container px-sm-3">
                    <b-navbar-brand :to="{name: 'home'}" :class="{'py-0': isHomeschoolStore}">
                        <img v-if="!isHomeschoolStore" src="https://cdn.studiesweekly.com/logo/2017+SW_horiz-black.png" alt="logo">
                        <img v-if="isHomeschoolStore" src="https://cdn.studiesweekly.com/store/2021_SW_horiz_Homeschool.png" alt="logo">
                    </b-navbar-brand>

                    <b-navbar-nav class="d-lg-none d-block ml-auto mr-3">
                        <!--
                        NOTE: there are two cart links. the cart link needs to stay outside of the mobile collapse menu, and there is a lot of flex going on, so this link needed to be duplicated
                        TODO: work out a way for this link to not have to be duplicated
                        -->
                        <b-nav-item :to="{name: 'cart'}">
                            <div class="d-flex flex-nowrap">
                                <div class="align-self-center ml-2">
                                    <font-awesome-icon :icon="['fad', 'shopping-cart']" />
                                </div>
                                <div v-if="products && products.length" class="align-self-center ml-2">
                                    <span class="badge badge-success">{{productsTotal(products)}}</span>
                                </div>
                            </div>
                        </b-nav-item>
                    </b-navbar-nav>

                    <b-navbar-toggle target="nav-collapse">
                        <font-awesome-icon :icon="['far', 'bars']" />
                    </b-navbar-toggle>

                    <b-collapse id="nav-collapse" is-nav>
                        <b-navbar-nav class="my-lg-0 my-2 text-uppercase">
                            <template>
                                <b-nav-item v-show="showSingleSocialStudies" :to="{name: 'social-studies', params: {subject: 'social-studies'}}">
                                    Social Studies
                                </b-nav-item>
                                <b-nav-item-dropdown v-show="!showSingleSocialStudies">
                                    <template #button-content>
                                        Social Studies
                                    </template>
                                    <b-dropdown-item to="/social-studies" class="text-left">
                                        <span v-if="selectedState == 'CA'">2022 New</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item>
                                        <router-link :to="{name: 'n-social-studies'}">
                                            <span v-if="selectedState == 'CA'">2018 Adopted</span>
                                        </router-link>
                                    </b-dropdown-item>


                                </b-nav-item-dropdown>
                            </template>
                            <template>
                                <b-nav-item v-if="sciencePages.length === 1" :to="sciencePages[0]">
                                    Science
                                </b-nav-item>
                                <b-nav-item-dropdown v-else>
                                    <template #button-content>
                                        Science
                                    </template>
                                    <b-dropdown-item to="/science" class="text-left">
                                        <template v-if="isNationalPrimaryScienceProduct">Science SW</template>
                                        <template v-else>Explore Science</template>
                                    </b-dropdown-item>
                                    <b-dropdown-item to="/science2" class="text-left">
                                        <template v-if="!isNationalPrimaryScienceProduct">Science SW</template>
                                        <template v-else>Explore Science</template>
                                    </b-dropdown-item>
                                </b-nav-item-dropdown>
                            </template>
                            <b-nav-item-dropdown text="Health & Wellness">
                                <b-dropdown-item :to="{name: 'health', params: {subject: 'health'}}">Health & Wellness</b-dropdown-item>
                                <b-dropdown-item :to="{name: 'wb-poster'}" v-if="!isCAHomeschool">Poster Pack</b-dropdown-item>
                            </b-nav-item-dropdown>
<!--                            <b-nav-item :to="{name: 'well-being', params: {subject: 'well-being'}}">-->
<!--                                Well-Being-->
<!--                            </b-nav-item>-->
                            <b-nav-item-dropdown text="Other">
                                <b-dropdown-item to="/#homeschool" v-if="!isHomeschoolStore">
                                    Homeschool Store
                                </b-dropdown-item>
                                <b-dropdown-item to="/#school" v-if="isHomeschoolStore">
                                    School Store
                                </b-dropdown-item>
                                <b-dropdown-item v-if="!isCAHomeschool" :to="{name: 'summer-school', params: {subject: 'summer-school'}}">
                                    ELA/Summer
                                </b-dropdown-item>
                                <b-dropdown-item v-if="!isHomeschoolStore" :to="{name: 'pre-k', params: {subject: 'pre-k'}}">
                                    Pre-K
                                </b-dropdown-item>
                                <b-dropdown-item :to="{name: 'wb-poster'}">
                                    Poster Pack
                                </b-dropdown-item>
                            </b-nav-item-dropdown>


<!--                            <b-nav-item v-if="NewSS.length" :to="{name: 'national-social-studies', params: {subject: 'national-social-studies'}}">-->
<!--                                <strong>New</strong> Social Studies-->
<!--                            </b-nav-item>-->
<!--                            <b-nav-item :to="{name: 'civil-rights'}" v-if="!isHomeschoolStore">-->
<!--                                Civil Rights-->
<!--                            </b-nav-item>-->

                            <!--
                            <b-nav-item :to="{name: 'science', params: {subject: 'science'}}">
                                Science
                            </b-nav-item> -->
                            <!-- <b-nav-item :to="{name: 'supplemental-products'}">
                                Supplemental
                            </b-nav-item> -->
                        </b-navbar-nav>

                        <b-navbar-nav class="ml-auto">

                            <b-navbar-nav class="text-uppercase">
                                <!-- desktop cart link -->
                                <b-nav-item :to="{name: 'cart'}" class="d-lg-block d-none">
                                    <div class="d-flex flex-nowrap">
                                        <div class="align-self-center ml-2">
                                            <font-awesome-icon :icon="['fad', 'shopping-cart']" />
                                        </div>
                                        <div v-if="products && products.length" class="align-self-center ml-2">
                                            <span class="badge badge-success">{{productsTotal(products)}}</span>
                                        </div>
                                    </div>
                                </b-nav-item>

                                <!-- User dropdown -->
                                <b-nav-item-dropdown v-if="$auth.user() && $auth.user().id" right>
                                    <!-- Using 'button-content' slot -->
                                    <template v-slot:button-content>
                                        <Gravatar class="gravatar rounded-circle" :email="$auth.user().username" :size="25" />
                                        <span class="d-lg-none ml-2">{{$auth.user().name}}</span>
                                    </template>
                                    <b-dropdown-text class="text-muted text-nowrap small d-lg-block d-none">
                                        {{$auth.user().name}}
                                    </b-dropdown-text>
                                    <b-dropdown-item :to="{name: 'dashboard'}">
                                        <font-awesome-icon :icon="['fad', 'tachometer']" fixed-width /> Dashboard
                                    </b-dropdown-item>
                                    <b-dropdown-item href="#" @click.prevent="logout">
                                        <font-awesome-icon :icon="['fad', 'sign-out']" fixed-width /> Log Out
                                    </b-dropdown-item>
                                </b-nav-item-dropdown>

                                <!-- Temp Logged in -->
                                <b-nav-item-dropdown v-else-if="credentials != null">
                                    <template v-slot:button-content>
                                        <span>{{credentials.email | shortText}}</span>
                                    </template>
                                    <b-dropdown-item href="#" @click.prevent="logout">
                                        <font-awesome-icon :icon="['fad', 'sign-out']" fixed-width /> Log Out
                                    </b-dropdown-item>
                                </b-nav-item-dropdown>

                                <!-- login -->
                                <b-nav-item v-else :to="{name: 'login'}">
                                    <font-awesome-icon :icon="['fad', 'sign-in']" fixed-width />Store Log In
                                </b-nav-item>
                            </b-navbar-nav>
                        </b-navbar-nav>
                    </b-collapse>
                </div>
            </b-navbar>

            <!-- Nav Message -->
            <b-navbar id="navmsg" type="dark" class="p-0 m-0" v-if="!hideMsg">
                <div class="text-center w-100 m-0 p-0">
                    <b-alert variant="warning" show class="d-block m-0 p-2" v-if="true">
                        <!-- NAV MSG GOES HERE -->
                        <strong>Studies Weekly will be closed November 26-27</strong> to allow our employees to enjoy the holiday with their families. We hope you’re able to enjoy this time with your loved ones as well! For support, please email support@studiesweekly.com, and we’ll respond when we return on November 30. <strong>Our last shipping day before the break is November 18</strong>; shipping resumes November 30. Happy Thanksgiving!
                    </b-alert>
                    <!-- NAV MSG GOES HERE -->

                    <div>
                    <slot name="navMsg" class="d-block">
                        <div v-if="messages && messages.navMessage" v-html="messages.navMessage"></div>
                    </slot>
                    </div>
                </div>
            </b-navbar>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import Gravatar from 'vue-gravatar'

import {publicationStates} from '@/common/states'

export default {
    name: 'navbar',
    data: () => ({
        isLoading: false,
        states: publicationStates,
        current_year: new Date().getFullYear(),
        message: "Welcome to the Studies Weekly Store!",
        showCart: false,
        show: false,
    }),
    props: ['state', 'subject', 'hideMsg'],
    computed: {
        isCAHomeschool() {
            return this.isHomeschoolStore && this.selectedState == 'CA';
        },
        ...mapState({
            products: state => state.cart.products,
            stateData: state => state.stateData.stateData,
            messages: state => state.stateData.stateData.messages,
            affiliate: state => state.affiliate,
            publicationResources: state => state.stateData.publicationResources,
            selectedState: state => state.stateData.selectedState,

            selectedYear: state => state.stateData.selectedYear,
            credentials: state => state.checkout.credentials,
            schoolYear: state => state.stateData.currentSchoolYear,
        }),
        ...mapGetters({
            isHomeschoolStore: 'isHomeschoolStore',
            showBothSchoolYears: 'showBothSchoolYears',
            sciencePubs: 'getSciencePublications',
            exSciencePubs: 'getExploreSciencePublications',
            adoptedSSPubs: 'getAdoptedSocialStudiesPublications',
        }),
        sciencePages() {
            let pages = [];
            if (this.sciencePubs.length > 0) {
                pages.push('/science');
            }
            if (this.exSciencePubs.length > 0) {
                pages.push('/science2');
            }
            return pages;
        },
        isNationalPrimaryScienceProduct() {
            const swappedStates = ['AL', 'IN', 'TN', 'TX', 'UT'];

            return !(swappedStates.includes(this.selectedState));
        },
        showBothSciences() {
            let shouldShow = this.exSciencePubs.length > 0 && !this.isHomeschoolStore;
            console.log("Show Both Sciences: ", shouldShow);
            return shouldShow;
        },
        showSingleSocialStudies() {
            if (this.isHomeschoolStore && this.selectedState == 'CA')
                return true;

            return (this.selectedState != 'CA');
            // return !(this.selectedState == 'CA' && !this.isHomeschoolStore);
        }
    },
    watch: {
        // 'stateData': {
        //     handler (stateData) {
        //         console.log(stateData)
        //         if (stateData.state) {
        //             this.getStateData(stateData.state)
        //         }
        //     },
        //     deep: true,
        //     immediate: true
        // }
        'isHomeschoolStore': {
            handler (isHomeschoolStore) {
                console.log("Navbar: watching isHomeschoolStore ", isHomeschoolStore);
                if (isHomeschoolStore && this.$auth.user() && this.$auth.user().id) {
                    this.getStateData();
                }
            },
            immediate: false,
        },
        '$auth.watch': {
            handler() {
                if (this.$auth.check() && this.isHomeschoolStore) {
                    this.getStateData();
                }
                else if (!this.$auth.check() && this.isHomeschoolStore) {
                    this.$store.commit('setSelectedState', "NA");
                }
            },
            immediate: false,
        }
    },
    components: {
        Gravatar
    },
    methods: {
        getStateData () {
            const versionPreview = this.$route.query.preview ? this.$route.query.preview : 0;
            let state = this.shortState(this.state);

            // Get customer homeschool state
            if (this.isHomeschoolStore && this.$auth.check()) {
                ;
                let customerStates = this.$auth.user().customer_states || ["NA"];
                if (customerStates.length > 0 && this.selectedState !== customerStates[0]) {
                    this.isLoading = true;
                    this.$store.commit('setSelectedState', customerStates[0]);
                    this.$store.dispatch('getStateData', { state: customerStates[0] })
                        .finally(() => { this.isLoading = false; });
                    this.$store.dispatch('getSupplementalProducts', customerStates[0]);
                    return;
                }
            }


            // State Switched
            if (state && state !== this.selectedState) {
                this.$store.dispatch('getStateData', {state: state})
                return;
            }

            // Stale data
            const MAX_AGE = 1000 * 60 * 60 * 24 * 7; // 1 week
            let now = new Date().getTime();
            let last = this.$store.getters.getLastStateDataFetchTime;
            if (!last || (now - last) > MAX_AGE) {
                console.log("State data is stale, refetching");
                this.$store.dispatch('getStateData', {state: this.selectedState || state || "NA"});
                return;
            }

            // Empty state data
            if (!this.selectedState && !this.stateData.state) {
                this.$store.dispatch('getStateData', {})
                return;
            }

            // View Draft, should be deprecated
            if (this.selectedState && (!this.stateData.state || this.$route.query.preview)) {
                this.$store.dispatch('getStateData', {state: this.selectedState, draft: versionPreview})
                return;
            }
        },
        setSelectedYear(ev) {
            let year = event.target.value;

            if (year && year != this.stateData.year) {
                this.isLoading = true;
                this.$store.commit('setSelectedYear', year)
                this.$store.dispatch('getStateData', {'state': this.selectedState, 'year': year})
                    .then((response) => {
                        if (this.subject) {
                            var subject = this.subject

                            this.$router.push({subject, params: {state: this.selectedState}})
                            this.$forceUpdate();
                        }
                    }).finally(() => {
                        this.isLoading = false;
                    })
                this.$store.dispatch('getSupplementalProducts', this.selectedState)
            }
        },
        setSelectedState (event) {
            var state = event.target.value

            if (state && state != this.stateData.state) {
                this.isLoading = true;
                this.$store.dispatch('getStateData', {'state': state})
                    .finally(() => {
                        this.isLoading = false;
                    })
                this.$store.dispatch('getSupplementalProducts', state)

                this.$store.commit('setSelectedState', state)

                if (this.subject) {
                    var subject = this.subject

                    this.$router.push({subject, params: {state: state}})
                }
            }
        },
        productsTotal (products) {
            var productsTotals = []
            _.forEach(products, product => {
                productsTotals.push(product.quantity)
            })
            return _.sum(productsTotals)
        },
        fullState (selectedState) {
            var fullState = null
            _.forEach(this.states, state => {
                if (selectedState == state.state) {
                    fullState = state.fullState
                }
            })
            return fullState
        },
        logout() {
            var redirect = this.$auth.redirect()
            this.$store.commit('clearDashboard');

            this.$auth.logout({
                makeRequest: true,
                params: {},
                redirect: {
                    name: redirect ? redirect.from.name : 'login'
                },
                success (response) {
                    // clear stored credentials for new account if they exist
                    this.$store.commit("storeNewAccountCredentials", null)
                    if (this.isHomeschoolStore)
                        this.$store.commit('setSelectedState', "NA");
                },
                error (error) {
                    this.$swal("Error", error.message, "error")
                }
            })
        },
        setTopbarPadding () {
            let height = null

            if (this.$refs.topbar) {
                height = this.$refs.topbar.clientHeight

                document.body.style.paddingTop = height + 'px'

                this.$emit("setTopbarPadding", height)
            }
        },
        shortState (routeState) {
            var shortState = null

            if (routeState) {
                _.forEach(this.states, state => {
                    if (routeState.toLowerCase() == state.fullState.toLowerCase()) {
                        shortState = state.state
                    }
                    if (routeState.toLowerCase() == state.state.toLowerCase()) {
                        shortState = state.state
                    }
                })
            }

            return shortState
        },
    },
    filters: {
        shortText(value) {
            let shortString = value.substring(0, 10);
            if (value.length > 10)
                shortString += "...";
            return shortString;
        }
    },
    mounted () {
        this.getStateData()
        if (this.selectedYear == null)
            this.$store.commit('setSelectedYear', this.schoolYear)

        window.addEventListener('resize', this.setTopbarPadding)

        this.setTopbarPadding()
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/_colors.scss";
.loader {
    margin-top: 5px;
    margin-left: 5px;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 25px;
    height: 25px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
.main-navbar {
    .navbar-brand > img {
        width: 220px;
        height: auto;
    }

    .navbar-nav {
        .nav-link,
        .nav-link:focus  {
            color: $dark;
        }

        .nav-link:hover {
            color: $primary;
        }

        .nav-link.active {
            color: $primary;
        }

        .dropdown-item {
            a, span {
                text-decoration: none;
                color: $dark;
            }
            a:hover, span:hover {
                color: $primary;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";


.toolbar {
    background-color: darken($info, 10%);
}

#navmsg {
    background-color: white;
    color: red;
}
#navmsg a:link {
    color: red;
    font-weight: bold;
}
#navmsg a:visited {
    color: darkred;
    font-weight: bold;
}

.main-navbar {
    .navbar-brand > img {
        width: 220px;
        height: auto;
    }

    .navbar-nav {
        .badge {
            font-size: 100%;
        }
    }
}

@media (max-width: 1199px) { .main-navbar { .navbar-brand > img { width: 210px; } } }
@media (max-width: 991px ) { .main-navbar { .navbar-brand > img { width: 200px; } } }
@media (max-width: 767px ) { .main-navbar { .navbar-brand > img { width: 190px; } } }

// @media (max-width: 639px ) { .main-navbar { .navbar-brand > img { width: 180px; } } }
// @media (max-width: 419px ) { .main-navbar { .navbar-brand > img { width: 170px; } } }
// @media (max-width: 379px ) { .main-navbar { .navbar-brand > img { width: 160px; } } }
</style>
